import { define } from 'wicked-elements'
import { toUri } from '../helpers.js'
import bus from '../bus.js'

define('[data-component~="intro"]', {
  init () {
    this.$button = this.element.querySelector('button')
    this.close = this.close.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)
  },
  close () {
    this.element.remove()
  },
  handleClickOutside (e) {
    if (e.target === e.currentTarget) {
      this.close()
    }
  },
  handleConnected () {
    // If we are on the homepage, reveal the modal.
    // Otherwise, close the modal.
    const currentUri = toUri(window.location.pathname)
    if (currentUri === '') {
      this.element.classList.replace('hidden', 'flex')
      this.element.addEventListener('click', this.handleClickOutside)
      this.$button.addEventListener('click', this.close)
    } else {
      this.close()
    }
  },
  connected () {
    this.handleConnected()
    bus.on('intro:close', this.close)
  },
  disconnected () {
    bus.removeListener('intro:close', this.close)
    this.element.removeEventListener('click', this.handleClickOutside)
    this.$button.removeEventListener('click', this.close)
  }
})